var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrap",style:(_vm.wrap_styles)},[_c('img',{class:_vm.lazyLoaded && this.src !== '' ? 'loaded' : null,style:(_vm.img_styles),attrs:{"src":"data:image/gif;base64,R0lGODlhAwADAIAAAP///8zMzCh2BAAAAAAALAAAAAADAAMAAAIEBHIJBQA7","data-src":this.src,"alt":this.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }